import React, { useState } from 'react';
import { Button, CircularProgress, Alert, Box, Typography, Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import { CloudUpload } from '@mui/icons-material';
import { loadSurgicalProceduresToFirestore } from '../scripts/loadSurgicalProcedures';

const LoadProceduresButton = () => {
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [open, setOpen] = useState(false);

  const handleLoad = async () => {
    setLoading(true);
    setResult(null);
    
    const loadResult = await loadSurgicalProceduresToFirestore();
    
    setResult(loadResult);
    setLoading(false);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setResult(null);
  };

  return (
    <Box>
      <Button
        variant="contained"
        color="primary"
        startIcon={loading ? <CircularProgress size={20} color="inherit" /> : <CloudUpload />}
        onClick={handleLoad}
        disabled={loading}
      >
        {loading ? 'Cargando...' : 'Cargar Procedimientos Quirúrgicos a BD'}
      </Button>

      <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
        <DialogTitle>
          {result?.success ? '✅ Carga Exitosa' : '❌ Error en la Carga'}
        </DialogTitle>
        <DialogContent>
          {result?.success ? (
            <Box>
              <Alert severity="success" sx={{ mb: 2 }}>
                Los procedimientos quirúrgicos se cargaron correctamente en Firestore
              </Alert>
              <Typography variant="body1">
                📊 <strong>Resumen:</strong>
              </Typography>
              <Typography variant="body2" sx={{ mt: 1, pl: 2 }}>
                • Total de procedimientos en archivo: <strong>{result.total}</strong>
              </Typography>
              <Typography variant="body2" sx={{ pl: 2 }}>
                • Procedimientos agregados: <strong style={{ color: '#2e7d32' }}>{result.added}</strong>
              </Typography>
              <Typography variant="body2" sx={{ pl: 2 }}>
                • Procedimientos existentes (saltados): <strong>{result.skipped}</strong>
              </Typography>
              <Typography variant="body2" sx={{ mt: 2, fontStyle: 'italic', color: '#666' }}>
                Los procedimientos ya están disponibles en el formulario de cirugías
              </Typography>
            </Box>
          ) : (
            <Alert severity="error">
              {result?.error || 'Ocurrió un error al cargar los procedimientos'}
            </Alert>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default LoadProceduresButton;
